import { GetUserDetails } from '../../services/config'
import { ISchool } from '../../interfaces/school.interface'

export class FbPixels {
  schoolId: string
  pixelId: string
  constructor(schoolId: string, pixelId: string) {
    this.schoolId = schoolId
    this.pixelId = pixelId
  }

  public async initPixels() {
    try {
      if (this.pixelId) {
        return
      }

      const options = {
        autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
        debug: false, // enable logs
      }
      const advancedOptions: any = {}
      const userDetails = GetUserDetails()
      if (userDetails?.email) {
        advancedOptions['em'] = userDetails?.email
      }

      const ReactPixel = await import('react-facebook-pixel').then(
        x => x.default,
      )
      ReactPixel.init(this.pixelId, advancedOptions, options)
    } catch (e) {
      console.log(e, 'Error initPixels')
    }
  }

  public async trackPageView() {
    if (!this.pixelId) {
      return
    }

    try {
      const ReactPixel = await import('react-facebook-pixel').then(
        x => x.default,
      )
      ReactPixel.pageView() // For tracking page view
    } catch (e) {
      console.log(e, 'Error trackPageView')
    }
  }

  public async trackAddToCart(contentName: string) {
    if (!this.pixelId) {
      return
    }
    const ReactPixel = await import('react-facebook-pixel').then(x => x.default)
    ReactPixel.track('AddToCart', { content_name: contentName })
  }

  public async trackCompleteRegistration() {
    if (!this.pixelId) {
      return
    }
    const ReactPixel = await import('react-facebook-pixel').then(x => x.default)
    ReactPixel.track('CompleteRegistration')
  }

  public async trackPurchase(contentName: string) {
    if (!this.pixelId) {
      return
    }
    const ReactPixel = await import('react-facebook-pixel').then(x => x.default)
    ReactPixel.track('Purchase', { content_name: contentName })
  }

  public async trackSearch(searchString: string) {
    if (!this.pixelId) {
      return
    }
    const ReactPixel = await import('react-facebook-pixel').then(x => x.default)
    ReactPixel.track('Search', { search_string: searchString })
  }

  public async trackViewContent(contentName: string) {
    if (!this.pixelId) {
      return
    }
    const ReactPixel = await import('react-facebook-pixel').then(x => x.default)
    ReactPixel.track('ViewContent', { content_name: contentName })
  }

  public async trackLead() {
    if (!this.pixelId) {
      return
    }
    const ReactPixel = await import('react-facebook-pixel').then(x => x.default)
    ReactPixel.track('Lead')
  }
}

export const initFbPixels = async (schoolId: string, pixelsId: string) => {
  if (pixelsId) {
    return
  }
  const fbPixels = new FbPixels(schoolId, pixelsId)
  await fbPixels.initPixels()
}

export const trackFbPixelsPageView = async (
  schoolId: string,
  pixelsId: string,
) => {
  if (!pixelsId) {
    return
  }
  const fbPixels = new FbPixels(schoolId, pixelsId)
  await fbPixels.trackPageView()
}

export const trackFbPixelsRegistrationToSchoolDetails = async (
  schoolDetails: ISchool,
) => {
  if (!schoolDetails?.fb_pixels_id) {
    return
  }
  const fbPixels = new FbPixels(schoolDetails?._id, schoolDetails?.fb_pixels_id)
  await fbPixels.trackCompleteRegistration()
}

export const trackFbPixelsPurchase = async (
  schoolDetails: ISchool,
  contentName: string,
) => {
  if (!schoolDetails?.fb_pixels_id) {
    return
  }
  const fbPixels = new FbPixels(schoolDetails?._id, schoolDetails?.fb_pixels_id)
  await fbPixels.trackPurchase(contentName)
}

export const trackFbPixelsAddToCart = async (
  schoolDetails: ISchool,
  contentName: string,
) => {
  if (!schoolDetails?.fb_pixels_id) {
    return
  }
  const fbPixels = new FbPixels(schoolDetails?._id, schoolDetails?.fb_pixels_id)
  await fbPixels.trackAddToCart(contentName)
}
